// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  data: {},
  checklistArray: [
    {
      title: "Switch y llave",
      checklistName: "switchAndKey",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Funciones Control terrestre",
      checklistName: "funcionesControlTerrestre",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Botones y palancas terrestres",
      checklistName: "botonesPalancaTerrestre",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Funciones Control aéreo",
      checklistName: "funcionesControlAereo",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Botones y palancas aéreas",
      checklistName: "botonesPlacasAereas",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Clavija de alimentación",
      checklistName: "clavijaAlimentacion",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Funciones del sistema Hidráulico",
      checklistName: "funcionesSistemaHidraulico",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Clavija y funcionamiento del cargador",
      checklistName: "clavijaFuncionamiento",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Llantas (estética)",
      checklistName: "llantasEstetica",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Cubos reductores libres de playo",
      checklistName: "cubosReductoresLibresPlayo",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Rines",
      checklistName: "rines",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Baterías (carga óptima)",
      checklistName: "bateriasCargaOptima",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Canastilla y barandal (sin alteraciones)",
      checklistName: "canastillaBarandal",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Tornillería",
      checklistName: "tornilleria",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Pintura de todo el equipo",
      checklistName: "pinturaTodoElEquipo",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Limpieza",
      checklistName: "limpieza",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Daños visibles en la estructura",
      checklistName: "dañosVisiblesEstructura",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Tapa de baterías",
      checklistName: "tapaBaterias",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Tapa de tracciones",
      checklistName: "tapaTracciones",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Tapa de cargador",
      checklistName: "tapaCargador",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Tapa de controles terrestres",
      checklistName: "tapaControlesTerrestres",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Tapa del sistema hidráulico",
      checklistName: "tapaSistemaHidraulico",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Calcomanías",
      checklistName: "calcomanías",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Características y capacidad",
      checklistName: "caracteristicasCapacidad",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Responsabilidades del cliente",
      checklistName: "responsabilidadesDelCliente",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Tiempos de trabajo 3 x 8",
      checklistName: "tiemposDeTrabajo",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Torreta",
      checklistName: "torreta",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Extinguidor",
      checklistName: "extinguido",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Manual",
      checklistName: "manual",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Alarma de movimiento",
      checklistName: "AlarmaDeMovimiento",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Revisión de sistema de carga de batería",
      checklistName: "revicionSistemaCargaBateria",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Revisión de sistema mecánico y chasis",
      checklistName: "revisionSistemaMecanico",
      checked: false,
      incidence: false,
      notApply: false
    },
    {
      title: "Revisión de GPS",
      checklistName: "revisionGPS",
      checked: false,
      incidence: false,
      notApply: false
    }
  ],
  checklistFuelData: {
    notApply: false,
    value: 0
  },
  horometro: {
    notApply: false,
    image: null,
    value: null
  },
  albaranCheckListReason: "na",
  albaran: "",
  albaranType: "",
  emailNotifications: [],
  validEmailNotifications: true,
  checklistPhysicalImages: { titleSection: "Frente", src: null },
  videos: {
    titleSection: "Video de checklist",
    src: null,
    file: null
  },
  machineImages: [
    { titleSection: "Frente", src: null, id: 1 },
    { titleSection: "Posterior", src: null, id: 2 },
    { titleSection: "Lateral 1", src: null, id: 3 },
    { titleSection: "Lateral 2", src: null, id: 4 },
    { titleSection: "Llanta FD", src: null, id: 5 },
    { titleSection: "Llanta FI", src: null, id: 6 },
    { titleSection: "Lanta PD", src: null, id: 7 },
    { titleSection: "Llanta PI", src: null, id: 8 }
  ],
  branchs: [],
  // :: Firebase ref of checklist
  checklistRef: undefined,
  eventRef: undefined,
  productRef: undefined,

  // ohter data
  checklistQuery: [],
  checklistItemData: {},

  signChecklistDeliverer: {},
  signChecklistReceiver: {},
  allChecklistData: undefined,
  savedChecklists: [],

  statusDetail: {},
  itemsSavedActualState: {},
  itemsCheckSaved: {},
  lastChecklistSaved: false,
  orderMetadata: null
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
